import { ButtonHTMLAttributes, FC } from "react";
import googleIcon from "@/assets/images/google-icon-logo.svg?react";
import { clsxm } from "@/utils/clsxm";

interface IGoogleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  version: "v1" | "v2";
}

const styleVersions = {
  v1: "text-purple-3 !border-purple-3 disabled:bg-accent-button-v2/70",
  v2: "!border-gray disabled:bg-accent-button-v2/70",
};

export const GoogleButton: FC<IGoogleButtonProps> = ({
  className,
  version,
  ...props
}) => {
  return (
    <button
      className={clsxm(
        "bg-white text-center flex items-center font-semibold border rounded-full w-full justify-center p-[8px_60px] sm:px-0 gap-2",
        styleVersions[version],
        className
      )}
      {...props}
    >
      <img
        src={googleIcon as unknown as string}
        width={20}
        height={20}
        className="min-w-2.5"
        alt="Google logo"
      />
      <p>Continue with Google</p>
    </button>
  );
};
